import { render, staticRenderFns } from "./InjuredWorkerInfo.vue?vue&type=template&id=f762f4fc"
import script from "./InjuredWorkerInfo.vue?vue&type=script&lang=js"
export * from "./InjuredWorkerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports